const percentageFormatter = Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

export function formatPercentage(percent: number): string {
  return percentageFormatter.format(percent * 100) + '%';
}

export function formatDecimal(num: number): string {
  return percentageFormatter.format(num);
}